import React, { FC, useContext } from 'react';

import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { PageLoader } from 'client/blocks-redesign/Loader/PageLoader';

import { Context as SnapshotContext } from '../../context/snapshotContext';
import { Channel, IAppCard } from '../../model/skill';
import { AddNewAppCard } from '../AddNewAppCard/AddNewAppCard';
import { AppCard } from '../AppCard/AppCard';

import styles from './AppCardList.module.scss';

interface Props {
    channel: Channel;
}

export const SkillsCardList: FC<Props> = ({ channel }) => {
    const { snapshot } = useContext(SnapshotContext);

    if (!snapshot) {
        return <PageLoader />;
    }

    const cards: IAppCard[] = snapshot.skills
        .filter((skill) => skill.channel === channel)
        .map((skill) => ({
            id: skill.id,
            title: skill.draft.name,
            channel: skill.channel,
            onAir: skill.onAir,
            publishedAt: skill.updatedAt,
            logoUrl: skill.draft?.logo2?.url || '',
            lastOperation: snapshot.operations.find((operation) => operation.id === skill.id),
        }));

    return (
        <ErrorBoundary withHomepageLink>
            <div className={styles.installableAppCardList}>
                <AddNewAppCard aliceAppsCount={cards.length} channel={channel} />
                {cards.map((card) => (
                    <AppCard key={card.id} card={card} />
                ))}
            </div>
        </ErrorBoundary>
    );
};
